import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fadeUp } from "animations/variants";
import operatorApi from "api/operator/operator.api";

const ContactLocation = () => {
  const [operator, setOperator] = useState(null);

  useEffect(() => {
    const fetchOperator = async () => {
      const slug = "saigon-star"; // change if needed

      const { response, err } = await operatorApi.getPublicOperator(slug);

      if (response) {
        setOperator(response.data);
      }

      if (err) {
        console.error(err);
      }
    };

    fetchOperator();
  }, []);

  if (!operator) return null;
  return (
    <section className="bg-darkbg py-40 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="space-y-8"
        >
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="text-4xl font-heading text-neonYellow animate-neonFlicker"
          >
            LOCATION{" "}
          </motion.h2>

          <div className="space-y-2 text-gray-800">
            <p>{operator?.address}</p>

            <a
              href={operator.mapLink}
              target="_blank"
              rel="noreferrer"
              className="inline-block mt-3 text-sm tracking-widest underline hover:text-black transition"
            >
              OPEN IN MAPS
            </a>
          </div>

          <div className="pt-6 space-y-6 text-gray-900">
            {operator.openingHours?.map((day, index) => (
              <div key={index}>
                <p className="font-semibold">{day.day}</p>

                {day.slots.map((slot, i) => (
                  <p key={i}>
                    {slot.open} – {slot.close}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </motion.div>

        {/* MAP */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
          className="w-full h-[320px] md:h-[380px] rounded-md overflow-hidden shadow-lg"
        >
          <iframe
            title="Map"
            src={operator.mapEmbed}
            className="w-full h-full border-0"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ContactLocation;
